import useArticleImportRequest from "../useArticleImportRequest";
import { useState } from "react";
import apiUrl from "../../Apiurl";
import stilePulsanti from "../../interfaccia/stilePulsanti";

function CSVuploadQuery4({ utente }) {
  const uploadArticleCsv = useArticleImportRequest(utente);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const { buttonClassesWhite, buttonClassesGreen, buttonClassesRed } =
    stilePulsanti;

  const changeHandler = (event) => {
    setSelectedFile(event.target.files?.[0] ?? null);
    setIsFilePicked(Boolean(event.target.files?.length));
    setResult(null);
    setError("");
  };

  const handleSubmission = async () => {
    if (!selectedFile) {
      setError("Seleziona un file CSV prima di caricare.");
      return;
    }
    setLoading(true);
    setError("");
    setResult(null);

    const formData = new FormData();
    formData.append("uploaded_file", selectedFile);

    try {
      const response = await uploadArticleCsv(`${apiUrl}/csv/4`, formData);
      const payload = await response.json();
      if (!response.ok || payload?.success === false) {
        throw new Error(
          payload?.error ?? "Caricamento fallito. Controlla il file."
        );
      }
      setResult(payload?.result ?? {});
    } catch (err) {
      console.error("CSV query4 upload error", err);
      setError(err?.message ?? "Errore sconosciuto durante l'upload.");
    } finally {
      setLoading(false);
    }
  };

  const renderResult = () => {
    if (!result) return null;
    const updatedMongoList = Array.isArray(result.updatedMongoCodVS)
      ? result.updatedMongoCodVS
      : [];
    const updatedPubblicatoList = Array.isArray(result.updatedPubblicatoCodVS)
      ? result.updatedPubblicatoCodVS
      : [];
    const updatedPubblSoloPsList = Array.isArray(
      result.updatedPubblicatoSoloPsCodVS
    )
      ? result.updatedPubblicatoSoloPsCodVS
      : [];
    return (
      <div className="mt3 pa3 br2 bg-washed-green dark-green">
        <div className="b mb2">Risultato import</div>
        <ul className="pl3 mv0">
          <li>Righe processate: {result.processed ?? 0}</li>
          <li>Trovate in MODA_Articoli: {result.matchedModa ?? 0}</li>
          <li>Non trovate in MODA_Articoli: {result.missingModa ?? 0}</li>
          <li>Doc Mongo aggiornati: {result.updatedMongo ?? 0}</li>
          <li>
            Doc Mongo senza campi vuoti: {result.skippedMongoAlreadyFilled ?? 0}
          </li>
          <li>Doc Mongo mancanti: {result.missingMongo ?? 0}</li>
          <li>Pubblicato impostato a DA CONTROLLARE: {result.updatedPubblicato ?? 0}</li>
          <li>
            Pubblicato lasciato PROBLEMA/NON PUBBLICARE:{" "}
            {result.skippedPubblicatoBlocked ?? 0}
          </li>
          <li>Duplicati nel CSV: {result.duplicates ?? 0}</li>
          <li>Errori: {result.errors ?? 0}</li>
        </ul>
        {updatedMongoList.length > 0 && (
          <div className="mt3">
            <div className="b">Codici VS aggiornati (testi Mongo):</div>
            <div className="f6">{updatedMongoList.join(", ")}</div>
          </div>
        )}
        {updatedPubblicatoList.length > 0 && (
          <div className="mt3">
            <div className="b">Codici VS con pubblicato impostato a DA CONTROLLARE:</div>
            <div className="f6">{updatedPubblicatoList.join(", ")}</div>
          </div>
        )}
        {updatedPubblSoloPsList.length > 0 && (
          <div className="mt3">
            <div className="b">Codici VS senza Mongo (solo PS):</div>
            <div className="f6">{updatedPubblSoloPsList.join(", ")}</div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="flex colonnaTuttaPagina">
      <div className="w-40 fr pl4 pr4">
        <h1>Query 4 – testi PS</h1>
        <p>
          Carica il CSV UTF-8 con colonne:{" "}
          <code>
            id_product, name_IT, name_EN, description_short_IT, description_IT
          </code>
          .
        </p>
        <p>
          Per ogni id_product → MODA_Articoli.id_ps trova il relativo codice VS
          e, se il documento Mongo esiste, compila i campi vuoti:
          <br />
          <code>descrizioniSuPS.titolo.it/en</code>,{" "}
          <code>descrizioniSuPS.descBreve.it</code>,{" "}
          <code>descrizioniSuPS.descLunga.it</code>.
        </p>
        <p>
          Quando importa nuovi testi, registra utente e data dell'import e porta
          <code> pubblicato</code> da vuoto/NO a DA CONTROLLARE.
          Conserva SI, PROBLEMA e NON PUBBLICARE.
        </p>
        <input type="file" accept=".csv,text/csv" name="file" onChange={changeHandler} />
        {isFilePicked ? (
          <div className="mt2 f6">
            <p>File: {selectedFile?.name}</p>
            <p>Tipo: {selectedFile?.type || "n/d"}</p>
            <p>Dimensione: {selectedFile?.size} bytes</p>
          </div>
        ) : (
          <p className="gray">Seleziona un file</p>
        )}
        {error && (
          <div className="mt2 pa2 br2 bg-washed-red dark-red">{error}</div>
        )}
        <div className="mt3">
          <button
            onClick={handleSubmission}
            disabled={loading}
            className={`${buttonClassesGreen} mr2`}
          >
            {loading ? "Caricamento..." : "Carica CSV"}
          </button>
          <button
            type="button"
            className={buttonClassesWhite}
            onClick={() => {
              setSelectedFile(null);
              setIsFilePicked(false);
              setError("");
              setResult(null);
            }}
            disabled={loading}
          >
            Reset
          </button>
        </div>
        {renderResult()}
      </div>
      <div className="w-50 fr sezioneConScroll colonna90vh">
        <div className="pa3">
          <div className="b mb2">Promemoria formato CSV</div>
          <pre className="pa3 ba b--black-10 br2 bg-near-white">
            id_product;name_IT;name_EN;description_short_IT;description_IT
          </pre>
          <p className="f6 gray">
            I campi di testo sono trattati come HTML e non vengono sovrascritti
            se già presenti nel documento.
          </p>
        </div>
      </div>
    </div>
  );
}

export default CSVuploadQuery4;
